import { useTranslation as useI18nTranslation } from 'react-i18next'
import { LanguageType } from '@/stores/settingsStore'

// Custom hook that extends the i18next useTranslation hook
export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation()

  // Change language function
  const changeLanguage = (language: LanguageType) => {
    i18n.changeLanguage(language)
  }

  // Current language
  const currentLanguage = i18n.language as LanguageType

  return {
    t,
    i18n,
    changeLanguage,
    currentLanguage,
  }
}

export default useTranslation
